import _ from "lodash";
import React from "react";
import classes from "./FilterHeader.scss";
import I18nHOC from "UIComponents/I18nHOC";
import { ChecklistDropdown, FilterLabelButton } from "@toddle-edu/ds-web";
import { getLabelValueForMultiFilterLabelButton } from "Utils";
import { REGION_FILTER_OPTIONS } from "Platform/routes/Regions/modules/Module";

class FilterHeader extends React.PureComponent {
  getFilterButtonComponent = ({
    options,
    selectedOptions,
    allText,
    noneText,
    label,
  }) => {
    const { t } = this.props;
    const labelValue = getLabelValueForMultiFilterLabelButton({
      options,
      selectedOptions,
      t,
      allText,
      noneText,
    });

    return (
      <FilterLabelButton
        size={"medium"}
        variant={"plain"}
        labelValue={labelValue}
        label={label}
      />
    );
  };

  getFilters = () => {
    const { updateFilters, filters } = this.props;
    const filtersList = [
      {
        options: REGION_FILTER_OPTIONS,
        value: filters.regionIds,
        onChange: value => updateFilters({ regionIds: value }),
        showAllOption: true,
        buttonComponent: this.getFilterButtonComponent({
          options: REGION_FILTER_OPTIONS,
          selectedOptions: filters.regionIds,
          label: "Region",
        }),
        key: "regionIds",
        showSelectedOptionsOnTop: false,
      },
    ];

    return filtersList;
  };

  render() {
    const filterDropdowns = this.getFilters();
    return (
      <div className={classes.container}>
        <div className={classes.filtersContainer}>
          <div className={classes.filterandlabelcontainer}>
            {_.map(filterDropdowns, filterDropdownProps => {
              const {
                buttonComponent,
                key,
                options,
                value,
                onChange,
                showAllOption,
                showSelectedOptionsOnTop,
              } = filterDropdownProps;
              return (
                <React.Fragment key={key}>
                  <div className={classes.dropDownPosition}>
                    <ChecklistDropdown
                      options={options}
                      value={value}
                      onChange={onChange}
                      showAllOption={showAllOption}
                      showSelectedOptionsOnTop={showSelectedOptionsOnTop}
                    >
                      {buttonComponent}
                    </ChecklistDropdown>
                  </div>
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default I18nHOC({ resource: ["common"] })(FilterHeader);
